module.exports = __webpack_public_path__ + "static/media/192.e82b84a8.jpg";